import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxContainer,
    BoxTitle,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import SearchFilterBox from "../../Components/SearchFilterBox";
import { toast } from "react-toastify";
import SideModal from "../../Components/SideModal";
import ClientTable from "../../Components/LandlordPortal/Client/ClientTable";
import ViewPropsModel from "../../Components/LandlordPortal/Client/ViewPropsModel";

const ClientList = () => {
    const searchOptions = [
        { label: "Mobile", value: 1 },
        { label: "Name", value: 2 },
    ];

    const user = useSelector((state) => state.UserReducer.user);

    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState([]);
    const [filterType, setFilterType] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [showViewProps, setShowViewProps] = useState(false);

    // ---------------- API FUNCTION ----------------
    const fetchFunction = async ({ searchQuery, filterType }) => {
        const response = await axios.get(
            `${Config.apiUrl}/landlord/list/clients`,
            {
                params: {
                    s: searchQuery || "",
                    t: filterType || "",
                },
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: (res) => {
            if (res?.isSuccess) {
                setApiData(res.list || []);
            }
        },
        onError: (err) => {
            toast.error(err?.response?.data?.msg || "An Error Occurred");
        },
    });

    // ---------------- SINGLE API TRIGGER ----------------
    useEffect(() => {
        getListMutate({ searchQuery, filterType });
    }, [searchQuery, filterType, getListMutate]);

    // ---------------- HANDLERS ----------------
    const handleFilterChange = ({ searchQuery, filterType }) => {
        sessionStorage.removeItem("client_list_page");
        setSearchQuery(searchQuery || "");
        setFilterType(filterType || "");
    };

    const handleClearFilters = () => {
        setSearchQuery("");
        setFilterType("");
    };

    const handleCloseViewProps = () => {
        setShowViewProps(false);
    };

    return (
        <BoxContainer>
            <BoxHead>
                <BoxTitle className="!mb-0 whitespace-nowrap">
                    Primary Tenants
                    <Underline />
                </BoxTitle>
            </BoxHead>

            <SideModal isOpen={showViewProps} onClose={handleCloseViewProps} level="base">
                <ViewPropsModel
                    handleClose={handleCloseViewProps}
                    selectedData={selectedData}
                />
            </SideModal>

            <FilterTableWrapper>
                <FilterWrapper>
                    <div className="flex md:space-x-4 md:flex-row flex-col gap-4">
                        <SearchFilterBox
                            options={searchOptions}
                            handleFilterChange={handleFilterChange}
                            handleClearFilters={handleClearFilters}
                        />
                    </div>
                </FilterWrapper>

                {!error && !isLoading && apiData?.length > 0 && (
                    <TableWrapper>
                        <ClientTable
                            apiData={apiData}
                            setSelectedData={setSelectedData}
                            selectedData={selectedData}
                            setShowViewProps={setShowViewProps}
                        />
                    </TableWrapper>
                )}

                {!error && !isLoading && apiData?.length === 0 && <NotFoundModel />}
            </FilterTableWrapper>

            {error && !isLoading && <NotFoundModel />}
            {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
    );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;

export default ClientList;
